document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
        const question = item.querySelector('.faq-question');
        const icon = question.querySelector('.faq-icon');

        question.addEventListener('click', () => {
            const isOpen = item.classList.contains('open');

            faqItems.forEach(otherItem => {
                if (otherItem !== item && otherItem.classList.contains('open')) {
                    otherItem.classList.remove('open');
                    otherItem.querySelector('.faq-icon').textContent = '+';
                    otherItem.querySelector('.faq-icon').classList.remove('minus');
                    otherItem.querySelector('.faq-icon').classList.add('plus');
                }
            });

            if (isOpen) {
                item.classList.remove('open');
                icon.textContent = '+';
                icon.classList.remove('minus');
                icon.classList.add('plus');
            } else {
                item.classList.add('open');
                icon.textContent = '-';
                icon.classList.remove('plus');
                icon.classList.add('minus');
            }
        });
    });
});
